import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { ProjectCard } from "@/components/Cards";
import SectionHeader from "@/components/SectionHeader";
import PageSEO from "@/components/PageSEO";

const SECTIONS = ["Crop Farming", "Livestock", "Agricultural Production", "Agribusiness", "Agricultural Partnerships"];

export default function Agriculture() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { http.get("/projects?sector=agriculture").then(r => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageSEO
        title="Agriculture Investment Opportunities in Nigeria"
        description="Mayoto Agriculture — structured investment across crop farming, livestock and agribusiness value chains. From NGN 2,000 minimum with projected 45% p.a. cycle-based returns."
        canonicalPath="/agriculture"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">AGRICULTURE</p>
            <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128]" data-testid="agriculture-title">Investing in Productive Agriculture.</h1>
            <p className="mt-5 text-slate-600 max-w-xl leading-relaxed">
              Mayoto explores opportunities across farming, agricultural production, and the wider agricultural value chain — supporting commercially viable projects with sustainable growth potential.
            </p>
          </div>
          <div className="rounded-3xl overflow-hidden aspect-[4/3]">
            <img src="https://images.pexels.com/photos/9374827/pexels-photo-9374827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Agriculture" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide">
          <div className="flex flex-wrap gap-3 mb-10">
            {SECTIONS.map(s => (
              <span key={s} className="text-xs font-display font-bold tracking-widest text-[#0a1128] bg-white border border-slate-200 rounded-full px-4 py-2">{s.toUpperCase()}</span>
            ))}
          </div>
          <SectionHeader eyebrow="SELECTED PROJECTS" title="Live agriculture projects." />
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map(p => <ProjectCard key={p.id} p={p} />)}
            {projects.length === 0 && <div className="text-slate-500">No projects yet. Please check back soon.</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
